import script from "./PatientToBeScheduled.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientToBeScheduled.vue?vue&type=script&setup=true&lang=js"

import "./PatientToBeScheduled.vue?vue&type=style&index=0&id=18a02e55&lang=scss"

const __exports__ = script;

export default __exports__